import { axiosInstance } from '../../utils';

interface Payload {
  creationId: string;
  url: string;
  isAlreadyDraft: boolean;
}

export const cancelDraft = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/videos/cancel-draft', payload);
  return res.data;
};
